<ng-container *ngIf="dialog$ | async as dialog">
  <div *ngIf="dialog.initialState.headerText" class="modal-header justify-content-center">
    <div class="modal-title" [innerHTML]="dialog.initialState.headerText"></div>
  </div>
  <div class="modal-body" [innerHTML]=" dialog.initialState.textContent"></div>
</ng-container>
